import React, { useEffect, useState } from "react";
import Footer from "./components/Footer";

function DemoPage() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");

  useEffect(() => {
    if (window.updateChatwootURL) {
      window.updateChatwootURL();
    }

    // Force page to start at top on load
    window.scrollTo(0, 0);

    // Also ensure it stays at top after animations start
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      // Submit to Formspree
      const response = await fetch("https://formspree.io/f/mrbardge", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          role: formData.role,
          source: "demo_page_booking",
        }),
      });

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({ firstName: "", lastName: "", email: "", role: "" });
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="demo-page">
      {/* Top Section with Kody Robot */}
      <section className="kody-hero">
        <div className="kody-hero-background">
          <div className="kody-logo">
            <img
              src="/images/kodly-logo.png"
              alt="Kodly Logo"
              className="kodly-logo-image"
            />
          </div>
        </div>
        <div className="kody-hero-content">
          <div className="kody-text-section">
            <h1 className="kody-title">Meet Kody</h1>
            <div className="kody-subtitle">
              <div className="subtitle-line">Your AI Agent.</div>
              <div className="subtitle-line">Fully customizable.</div>
            </div>
          </div>
          <div className="kody-robot-section">
            <div className="kody-robot">
              <img
                src="/images/ai-agent.png"
                alt="Kody AI Agent"
                className="ai-agent-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You're About to See Section */}
      <section className="demo-description">
        <div className="demo-description-content">
          <div className="demo-description-text">
            <h2 className="demo-description-title">What You're About to See</h2>
            <p className="demo-description-paragraph">
              In this Demo, you will experience a fully tailored demo based on
              Radio Popular, with 30,000+ SKUs, hundreds of brands, and real
              product recommendations in a very competitive industry.
            </p>
          </div>
          <div className="demo-badge">
            <img
              src="/images/radio-popular-logo.png"
              alt="Radio Popular Logo"
              className="radio-popular-logo"
            />
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="use-cases">
        <div className="use-cases-container">
          <div className="use-case-card">
            <div className="use-case-content">
              <div className="use-case-title">Custom AI Agent</div>
              <div className="use-case-desc">
                built in code, tailored to your business and use cases
              </div>
            </div>
          </div>
          <div className="use-case-card">
            <div className="use-case-content">
              <div className="use-case-title">Smart Recommendations</div>
              <div className="use-case-desc">
                personalized suggestions that boost sales
              </div>
            </div>
          </div>
          <div className="use-case-card">
            <div className="use-case-content">
              <div className="use-case-title">Natural Conversations</div>
              <div className="use-case-desc">
                human-like answers that feel real
              </div>
            </div>
          </div>
          <div className="use-case-card">
            <div className="use-case-content">
              <div className="use-case-title">Omnichannel</div>
              <div className="use-case-desc">
                for your clients and your teams, in every channel
              </div>
            </div>
          </div>
          <div className="use-case-card">
            <div className="use-case-content">
              <div className="use-case-title">Integrations</div>
              <div className="use-case-desc">
                connect with your CRM, ERP, or any API
              </div>
            </div>
          </div>
          <div className="use-case-card">
            <div className="use-case-content">
              <div className="use-case-title">Human Handover</div>
              <div className="use-case-desc">
                smooth transition from AI to your agents
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking CTA Section */}
      <section className="booking-cta">
        <div className="booking-cta-content">
          <h2 className="booking-title">Book a live demo</h2>
          <div className="booking-benefits">
            <div className="benefit-item">
              <div className="benefit-check">✓</div>
              <span>100% free, no commitment</span>
            </div>
            <div className="benefit-item">
              <div className="benefit-check">✓</div>
              <span>Tailored to your business case</span>
            </div>
          </div>
          <form className="booking-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="firstName"
                placeholder="First name *"
                value={formData.firstName}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="lastName"
                placeholder="Last name *"
                value={formData.lastName}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="role"
                placeholder="Role *"
                value={formData.role}
                onChange={handleInputChange}
                required
              />
            </div>
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
            {submitStatus === "success" && (
              <div className="success-message">
                Thank you! We'll be in touch soon.
              </div>
            )}
            {submitStatus === "error" && (
              <div className="error-message">
                Something went wrong. Please try again.
              </div>
            )}
          </form>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default DemoPage;
